import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { getTheme2SearchFilterFieldCss } from "utils/theme2MultiSelect";
import { getStickyStockTableStickyColumnCss } from "utils/reactTableTheme";

const SEARCH_CUSTOMERS_PAGE_STYLES = (isTheme2) => `
  ${isTheme2 ? `
  .search-customers.search-customers--theme2 .search-customers-table-card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
  }
  ${getTheme2SearchFilterFieldCss({
    pageScopeSelector: ".search-customers.search-customers--theme2",
    filtersSelector: ".search-customers-table-card .search-customers-filters",
    rowClass: "search-customers-filters-row",
    colClass: "search-customers-filter-col",
  })}
  .search-customers.search-customers--theme2 .search-customers-filters-row {
    column-gap: 4px;
  }
  .search-customers.search-customers--theme2 .search-customers-filter-col {
    padding-left: 4px;
    padding-right: 4px;
  }
  .search-customers.search-customers--theme2 .search-customers-filter-col:first-child {
    padding-left: 0;
  }
  ` : ""}
  .search-customers-card-header.card-header {
    padding-top: 2px;
    padding-bottom: 0;
  }
  .search-customers-card-header h2,
  .search-customers-card-header h4 {
    font-size: 16px !important;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .search-customers .align-items-center {
    margin-top: 3px;
  }
  .search-customers .customers-table-edit-btn i,
  .search-customers .customers-table-edit-btn .tim-icons {
    color: #6b7280 !important;
  }
  .search-customers .customers-table-edit-btn:hover i,
  .search-customers .customers-table-edit-btn:hover .tim-icons,
  .search-customers .customers-table-edit-btn:focus i,
  .search-customers .customers-table-edit-btn:focus .tim-icons {
    color: #525252 !important;
  }
  .search-customers:not(.search-customers--theme2) .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 10px !important;
  }
  .search-customers.search-customers--theme2 .card .card-body {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 15px;
    padding-right: 15px;
  }
  .sticky-stock-table .rt-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) {
    text-align: center !important;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child {
    text-align: right !important;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) .rt-resizable-header-content {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child).-cursor-pointer .rt-resizable-header-content {
    padding-right: 2em;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child .rt-resizable-header-content {
    text-align: right;
    width: 100%;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) {
    text-align: center;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:last-child {
    text-align: right;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) > * {
    max-width: 100%;
    min-width: 0;
  }
  ${getStickyStockTableStickyColumnCss()}
`;

const CustomersCards = ({ isTheme2, filters, table, tableHeader, headerActions }) => {
  const { t } = useTranslation();

  const titleHeader = (
    <CardHeader className="search-customers-card-header">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="mb-0">{t("customers.title")}</h2>
        {headerActions}
      </div>
    </CardHeader>
  );

  return (
    <>
      <style>{SEARCH_CUSTOMERS_PAGE_STYLES(isTheme2)}</style>
      {isTheme2 ? (
        <Card className="search-customers-table-card">
          {titleHeader}
          <CardBody>
            <div className="search-customers-filters">{filters}</div>
            {table}
          </CardBody>
        </Card>
      ) : (
        <>
          <Card>
            {titleHeader}
            <CardBody>{filters}</CardBody>
          </Card>
          <Card className="mt-2">
            {tableHeader ? <CardHeader>{tableHeader}</CardHeader> : null}
            <CardBody>{table}</CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default CustomersCards;
